module.exports = __webpack_public_path__ + "media/images/creator/monitor/badge-1023809ca813a013ce7f43b5e84ffddd.png";